module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/proizvodi.json
// module id = 375
// module chunks = 109972596418722